module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-octagon-fill-2efb546d.svg";